var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"micad_unorderedList"},_vm._l((_vm.items),function(item){return _c('li',{key:item,staticClass:"micad_unorderedList_item"},[_vm._v(_vm._s(item))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }